export default __webpack_public_path__ + "static/media/blueArrow.2dd5935d.svg";